<template>
  <section :class="`ryoma-page-${$route.name}`">
    
    <h1>{{$t(`services.${currentObj.ref}.name`)}}</h1>
    <h4 v-html="$t(`services.${currentObj.ref}.excerpt`)"></h4>
    <article
      class="page-grid">
      <p v-html="$t(`services.${currentObj.ref}.desc`)"></p>
    </article>
    <figure :class="currentObj.ref">
      <img :src="getImg(currentObj.ref)" alt="">
    </figure>

    <Cta
      type="default"
      text="Select this solution"
      :service="currentObj.slug" />

    <TextComponent 
      type="detail"
      class="page-grid"
      :title="$t(`services.${currentObj.ref}.quote.text`)"
      :intro="$t(`services.${currentObj.ref}.quote.author`)"
      :authorDesc="$t(`services.${currentObj.ref}.quote.authorDesc`)"
      :tc1="$t(`services.${currentObj.ref}.tc-1`)"
      :tc2="$t(`services.${currentObj.ref}.tc-2`)"
      :tc3="$t(`services.${currentObj.ref}.tc-3`)"
      :align="'left'" />

    <Screen
      :fullscreen ="true"
      :type="'full'"
      :text="$t(`services.${currentObj.ref}.screen.text`)" />
      
    <!-- <h2>You need more?</h2> -->
    <!-- <h3>Choose the right service for you</h3>
    <Carousel /> -->


    <h3>Previous and next steps</h3>
    <ServiceWidget
      v-if="nextObj"
      :hasNav="true"
      :hasNext="true"
      :step="nextObj.step"
      :class="nextObj.ref"
      :slug="$t(`${nextObj.slug}`)"
      :name="$t(`${nextObj.name}`)"
      :excerpt="$t(`${nextObj.excerpt}`)"
      :origami="nextObj.origami"
      :single="true"
      @openService="openService" />

    <ServiceWidget
      v-if="prevObj"
      :hasNav="true"
      :step="prevObj.step"
      :class="prevObj.ref"
      :slug="$t(`${prevObj.slug}`)"
      :name="$t(`${prevObj.name}`)"
      :excerpt="$t(`${prevObj.excerpt}`)"
      :origami="prevObj.origami"
      :single="true"
      @openService="openService" />
    <!-- <transition
      appear
      :css="false"
      mode="out-in"
      @appear="animation"
      @enter="animation"
      @leave="animation"> -->
        <!-- <div 
          class="page-transition__top"></div>
        <div class="page-transition__bottom">
          <aside>

          </aside> -->
      <!-- <button 
        class="close"
        @click="goBack">
        <font-awesome-icon icon="low-vision" />
      </button> 
      </div>-->
    
    <!-- </transition> -->
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { TweenMax } from "gsap"

import Screen from '@/components/Screen.vue'
import Cta from '@/components/elements/Cta.vue'
import TextComponent from '@/components/TextComponent.vue'
// import DataContainer from '@/components/widgets/data-grid/Container.vue'
// import Carousel from '@/components/widgets/Carousel.vue'
import ServiceWidget from '@/components/widgets/ServiceWidget.vue'

import iaImage from "../assets/iaImage.png"
import frontImage from "../assets/frontImage.png"
import accessibilityImage from "../assets/ay11Image.png"
import uxImage from "../assets/uxImage.png"
import bannerImage from "../assets/bannerImage.png"
// import copywritingIcon from "../assets/copywriting.svg"
import legalImage from "../assets/legalImage.png"

export default {
  name:'service-details',
  data() {
    return {
      prevObj: null,
      nextObj:null
    }
  },
  components: {
    Cta,
    Screen,
    TextComponent,
    // DataContainer,
    ServiceWidget,
    // Carousel
  },
  beforeCreate() {
    TweenMax.set('header', {autoAlpha: 1});
  },
  computed: {
    ...mapGetters({
        services: 'services'
    }),
    // a computed getter
    currentObj: function () {
      
      const slug = this.$route.params.slug;
      const currentObj = this.services.filter(function(e) {
         return e.slug === slug
      })

      this.prevObjGenerator(currentObj[0])
      this.nextObjGenerator(currentObj[0])

      return currentObj[0];
    },
    heroInfo: function() {
      return {
        "title": this.currentObj.name,
        "text": this.currentObj.desc
      }
    }
  },
  methods: {
    prevObjGenerator: function (currentObj) {
      const step = currentObj.step;
      const prevObj = this.services.filter(function(e) {
         return e.step === step-1
      })
      
      this.prevObj = prevObj[0];
    },
    nextObjGenerator: function (currentObj) {
      
      const step = currentObj.step;
      const nextObj = this.services.filter(function(e) {
         return e.step === step+1
      })
      
      this.nextObj = nextObj[0];
    },
    openService: function (event, slug) {
      this.$router.push({name: 'service-details', params: { slug: slug }});
    },
    getImg: function (service) {
      switch (service) {
        case 'ia':
          return iaImage;
        case 'front':
          return frontImage;
        case 'accessibility':
          return accessibilityImage;
        case 'ux':
          return uxImage;
        case 'banner':
          return bannerImage;
        case 'legal':
          return legalImage;
          
        default:
          return 'https://via.placeholder.com/500x400';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/_mixins.scss';

section {
  @include grid-padding;
  @include grid(12);

  > * {
    grid-column: 1 / span 12;
   }

   h1,h4 {
    margin-bottom: $small_vmin;
    color: $gray_dark_2;

    @include respond-to(desktop) {
      line-height: 1.5;
      grid-column: 2 / span 10;
    
    }

    @include respond-to(tv) {
      grid-column: 2 / span 10;
    
    }
   }

  h1 {
    &:first-of-type {
      margin-top: $default_vmin;
    }
  }

  h3 {
    text-align: center;
    margin: $default_vmin 0;
  }

   @include respond-to(desktop) {

    article {
      &:first-of-type{
        grid-column: 2 / span 6;

        @include respond-to(tv) {
          grid-column: 2 / span 5;
        }
      }

      p {
        color: $gray_dark_2;
        line-height: 1.5;
      }
    }
   }

   figure {
     grid-row-start: 1;
     background: orange;
     margin-bottom: $default_vmin;

     &.ia,
     &.legal {
        display: flex;
        align-items: flex-end;
     }

     @include respond-to(desktop) {
      grid-column: 8 / span 4;
      grid-row-start: 3;
      margin-bottom: 0;
     }

     @include respond-to(tv) {
      grid-column: 7 / span 5;
     }
   }
}
</style>